module.exports = __webpack_public_path__ + "static/Grupo534-ba8a2432615b332efb3729a56c4505c9.png";